export default "__VITE_ASSET__CLR5fyoT__"